import { useState, useLayoutEffect, useEffect } from 'react';

const useMediaQuery = mediaQuery => {
  const [matches, setMatches] = useState(
    () => window.matchMedia(mediaQuery).matches,
  );
  useLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    const listener = e => setMatches(e.matches);
    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [mediaQuery]);

  return matches;
};

const useChoice = config => {
  const { dbKey, initial } = config;
  const [selected, setSelected] = useState(initial);

  const mergeActions = _ => {
    return {
      pick: v => setSelected(v),
      // api: config.cb(key,selected),
      clear: _ => setSelected(null),
    };
  };
  return {
    state: selected,
    actions: mergeActions(),
  };
};

const useControllableProp = ({ value, updater, defaultValue }) => {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(
    isControlled ? value : defaultValue,
  );
  const currentValue = isControlled ? value : internalValue;
  const currentUpdater = isControlled ? updater : e => setInternalValue(e);

  useEffect(() => {
    if (isControlled) {
      setInternalValue(value);
    }
  }, [isControlled, value]);

  return [currentValue, currentUpdater];
};

function usePersistedState(key, defaultValue) {
  const [state, setState] = useState(
    () => JSON.parse(localStorage.getItem(key)) || defaultValue,
  );
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return [state, setState];
}

const hooks = {
  useMediaQuery,
  useChoice,
  usePersistedState,
  useControllableProp,
};

export default hooks;
